import Icon from "components/UI/IconSVG/Icon";

import "./ProjectsGroupTitle.scss";

/**
 * @param {Object} props
 * @param {Number} props.count Сколько проектов группы сейчас на экране.
 * @param {?Number} [props.total] Сколько их всего, если загружены не все
 * (архив листается страницами). Совпал с count — не показываем.
 */
const ProjectsGroupTitle = ({ type, count, total, totalSum, expandedTypes, isMobile }) => {
  const displayType = type === "AVITO" ? "ОБЪЯВЛЕНИЯ" : type;
  const countText = total && total > count ? `${count} из ${total}` : `${count}`;

  return (
    <div className="projects-drafts__row-total">
      <div className="projects-drafts__row-total-project">
        <Icon className={`projects-drafts__row-accordion-icon ${expandedTypes ? "expanded" : ""}`} sprite="projects" name="accordion" color="#4F4F4F" />
        <h3 className="projects-drafts__row-title">Проекты {displayType} {isMobile && <br />} ({countText} шт.)</h3>
      </div>
      {totalSum && <p className={`projects-drafts__row-total-sum ${expandedTypes ? "other-color": ""}`}>Общая сумма: <span>{totalSum.toLocaleString()} ₽</span></p>}
    </div>
  );
};

export default ProjectsGroupTitle;
